export { default, getStaticProps } from 'src/pages/About'
